import React from "react";
import { twMerge } from "tailwind-merge";

type InputProps = {
  label?: string;
  error?: string | boolean;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error, className, label, ...props }, ref) => {
    return (
      <div className={twMerge("flex flex-col gap-1", className)}>
        {label && (
          <label htmlFor={props.id} className="ml-1 text-base font-semibold">
            {label}
          </label>
        )}
        <input
          type={props.type || "text"}
          ref={ref}
          className={twMerge(
            "block",
            "w-full",
            "rounded-lg",
            "px-2",
            "py-2.5",
            "text-gray-900",
            "ring-inset",
            "placeholder:text-gray-500",
            "focus:outline-none",
            "focus:ring-1",
            "border",
            "border-gray-500",
            "sm:leading-6",
            error && " ring-error border-error",
          )}
          {...props}
        />
        {typeof error === "string" && (
          <p className="ml-1 text-sm text-error">{error}</p>
        )}
      </div>
    );
  },
);

Input.displayName = "Input";
